import { render, staticRenderFns } from "./appbar.vue?vue&type=template&id=115e7840&scoped=true"
import script from "./appbar.vue?vue&type=script&lang=js"
export * from "./appbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e7840",
  null
  
)

export default component.exports